import React, { Component } from 'react';
import i18n from 'utils/translate';

const defaultProps = {
  openingHours: null
};

class OpeningHours extends Component {
  render() {
    const { openingHours } = this.props;
    return (
      <div>
        <div className="opening-hours">
          <b>{i18n('hours')}</b>
        </div>
        {this.renderDayLines(openingHours)}
      </div>
    );
  }

  renderDayLines(days) {
    const dayKeys = ['mon', 'tue', 'wed', 'thu', 'fri'];
    return dayKeys.map(day => {
      return (
        <div className="row row-no-gutters" key={day}>
          <div className="col-xs-3">{i18n(day)}</div>
          <div className="col-xs-9">{days[day] ? days[day] : '-'}</div>
        </div>
      );
    });
  }
}

OpeningHours.defaultProps = defaultProps;

export default OpeningHours;
